import * as idb from 'idb';

const DB = "INFODEMICS";

const CIRCLES = "CIRCLES";
const USERS = "USERS";
const TOPICS = "TOPICS";
const POSTS = "POSTS";
const CHILD_CIRCLES = "CHILD_CIRCLES";
const FEED = "FEED";
const CAMPAIGNS = "CAMPAIGNS";
const CIRCLE_CAMPAIGNS = "CIRCLE_CAMPAIGNS";
const BLOG_POSTS = "BLOG_POSTS";
const BLOG = "BLOG";
const RECOMMENDED_CIRCLES = "RECOMMENDED_CIRCLES";

export default class InMemoryDb {
    openDatabase() {
        return idb.openDB(DB, 1, {
            upgrade(db) {
                db.createObjectStore(CIRCLES);
                db.createObjectStore(USERS);
                db.createObjectStore(TOPICS);
                db.createObjectStore(POSTS);
                db.createObjectStore(CHILD_CIRCLES);
                db.createObjectStore(FEED);
                db.createObjectStore(CAMPAIGNS);
                db.createObjectStore(CIRCLE_CAMPAIGNS);
                db.createObjectStore(BLOG_POSTS);
                db.createObjectStore(BLOG);
                db.createObjectStore(RECOMMENDED_CIRCLES);
            }
        })
    }

    addCircle(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(CIRCLES, "readwrite");
            const bucket = transaction.objectStore(CIRCLES);   
            const board = data.boards || data.board || [];
            if (board.length > 0) {
                if (!board[0].profile) {
                    const circle = await bucket.get(data._id);
                    if (circle && Object.keys(circle).length > 0) {
                        const circle_board = s.boards || s.board || [];
                        if (circle_board.length > 0) {
                            board.map(s => s.profile = circle_board.find(b => b._id === s._id).profile);
                            if (data.boards) {
                                data.boards = board;
                            }
                            if (data.board) {
                                data.board = board;
                            }
                        }
                    }
                }
            }
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    addUser(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(USERS, "readwrite");
            const bucket = transaction.objectStore(USERS);          
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    addTopic(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(TOPICS, "readwrite");
            const bucket = transaction.objectStore(TOPICS);
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    addPost(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(POSTS, "readwrite");
            const bucket = transaction.objectStore(POSTS);    
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    getCircles() {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CIRCLES);
                const bucket = transaction.objectStore(CIRCLES);
                const data = await bucket.getAll();
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    getCircle(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CIRCLES);
                const bucket = transaction.objectStore(CIRCLES);
                const data = await bucket.get(id);
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    getUser(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(USERS);
                const bucket = transaction.objectStore(USERS);
                const data = await bucket.get(id);
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    getUsers() {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(USERS);
                const bucket = transaction.objectStore(USERS);
                const data = await bucket.getAll();
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    getCircleTopics(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(TOPICS);
                const bucket = transaction.objectStore(TOPICS);
                const data = await bucket.getAll();
                const circleTopics = data.filter(s => s.circle_id === id);
                circleTopics.map(s => s.type = "topic");
                resolve(circleTopics);
            }).catch(() => reject()); 
        });
    }

    getCirclePosts(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(POSTS);
                const bucket = transaction.objectStore(POSTS);
                const data = await bucket.getAll();
                const circlePosts = data.filter(s => s.circle_id === id);
                circlePosts.map(s => s.type = "media");
                resolve(circlePosts);
            }).catch(() => reject()); 
        });
    }

    getTopic(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(TOPICS);
                const bucket = transaction.objectStore(TOPICS);
                const data = await bucket.get(id);
                if (data && Object.keys(data).length > 0) {
                    data.type = "topic";
                }
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    getTopicPosts(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(POSTS);
                const bucket = transaction.objectStore(POSTS);
                const data = await bucket.getAll();
                const topicPosts = data.filter(s => s.topic_id === id);
                topicPosts.map(s => s.type = "media");
                resolve(topicPosts);
            }).catch(() => reject()); 
        });
    }

    getPost(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(POSTS);
                const bucket = transaction.objectStore(POSTS);
                const data = await bucket.get(id);
                if (data && Object.keys(data).length > 0) {
                    data.type = "media";
                }
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    removeCircle(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CIRCLES, "readwrite");
                const bucket = transaction.objectStore(CIRCLES);
                try {
                    await bucket.delete(id);
                } catch (e) { }
                resolve();
            }).catch(() => reject()); 
        });
    }

    getUserTopics(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(TOPICS);
                const bucket = transaction.objectStore(TOPICS);
                const data = await bucket.getAll();
                const userTopics = data.filter(s => s.profile_id === id);
                userTopics.map(s => s.type = "topic");
                resolve(userTopics);
            }).catch(() => reject()); 
        });
    }

    getUserPosts(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(POSTS);
                const bucket = transaction.objectStore(POSTS);
                const data = await bucket.getAll();
                const userPosts = data.filter(s => s.profile_id === id);
                userPosts.map(s => s.type = "media");
                resolve(userPosts);
            }).catch(() => reject()); 
        });
    }

    addChildCircle(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(CHILD_CIRCLES, "readwrite");
            const bucket = transaction.objectStore(CHILD_CIRCLES);
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    getChildCircle(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CHILD_CIRCLES);
                const bucket = transaction.objectStore(CHILD_CIRCLES);
                const data = await bucket.get(id);
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    removeChildCircle(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CHILD_CIRCLES, "readwrite");
                const bucket = transaction.objectStore(CHILD_CIRCLES);
                try {
                    await bucket.delete(id);
                    const parentTransaction = db.transaction(CIRCLES, "readwrite");
                    const parentBucket = parentTransaction.objectStore(CIRCLES);

                    const circles = await parentBucket.getAll();
                    const parentCircle = circles.children.find(s => s.child === id);
                    parentCircle.children = parentCircle.children.filter(s => s.child !== id);
                    await parentBucket.put(parentCircle, parentCircle._id);
                    resolve(parentCircle);
                } catch (e) { }
                resolve();
            }).catch(() => reject()); 
        });
    }

    getCircleChildren(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CHILD_CIRCLES);
                const bucket = transaction.objectStore(CHILD_CIRCLES);
                const data = await bucket.getAll();
                resolve(data.filter(s => s.parent_id === id));
            }).catch(() => reject()); 
        });
    }

    async deleteData() {
        try {
            const blog = await this.getBlog();
            const blogPosts = await this.getBlogPosts();
            const recommendedCircles = await this.getRecommendedCircles();
            
            idb.deleteDB(DB);
            this.openDatabase();

            this.saveBlog(blog);
            this.saveBlogPosts(blogPosts);
            this.saveRecommendedCircles(recommendedCircles);
        } catch(e) {
            idb.deleteDB(DB);
            this.openDatabase();
        }
    }

    saveFeed(feed) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(FEED, "readwrite");
            const bucket = transaction.objectStore(FEED);

            feed.map(data => bucket.put(data, data._id));
            await transaction.done;
        }).catch(() => {});
    }

    retrieveFeed() {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(FEED);
                const bucket = transaction.objectStore(FEED);
                const data = await bucket.getAll();
                resolve(data);
            }).catch(() => reject()); 
        });
    }

    addCampaign(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(CAMPAIGNS, "readwrite");
            const bucket = transaction.objectStore(CAMPAIGNS);
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    getUserCampaigns(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CAMPAIGNS);
                const bucket = transaction.objectStore(CAMPAIGNS);
                const data = await bucket.getAll();
                resolve(data.filter(s => s.profile_id === id));
            }).catch(() => reject()); 
        });
    }

    deleteCampaign(_id) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(CAMPAIGNS, "readwrite");
            const bucket = transaction.objectStore(CAMPAIGNS);

            bucket.delete(_id);
            await transaction.done;
        }).catch(() => {});
    }

    addCircleCampaign(data) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(CIRCLE_CAMPAIGNS, "readwrite");
            const bucket = transaction.objectStore(CIRCLE_CAMPAIGNS);
            bucket.put(data, data._id);
            await transaction.done;
        }).catch(() => {});
    }

    getCircleCampaigns(id) {
        return new Promise((resolve, reject) => {
            this.openDatabase().then(async(db) => {
                const transaction = db.transaction(CIRCLE_CAMPAIGNS);
                const bucket = transaction.objectStore(CIRCLE_CAMPAIGNS);
                const data = await bucket.getAll();
                resolve(data.filter(s => s.assets.circle.find(c => c.identifier === id)));
            }).catch(() => reject()); 
        });
    }

    deleteCampaign(_id) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(CIRCLE_CAMPAIGNS, "readwrite");
            const bucket = transaction.objectStore(CIRCLE_CAMPAIGNS);

            bucket.delete(_id);
            await transaction.done;
        }).catch(() => {});
    }

    saveBlogPosts(posts) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(BLOG_POSTS, "readwrite");
            const bucket = transaction.objectStore(BLOG_POSTS);

            posts.map(post => bucket.put(post, post._id));
            await transaction.done;
        }).catch(() => {});
    }

    getBlogPosts() {
        return new Promise((resolve) => {
            this.openDatabase().then(async(db) => {

                const transaction = db.transaction(BLOG_POSTS, "readwrite");
                const bucket = transaction.objectStore(BLOG_POSTS);
                const data = await bucket.getAll();
    
                resolve(data);
            }).catch(() => {});
        });
    }

    saveBlog(blog) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(BLOG, "readwrite");
            const bucket = transaction.objectStore(BLOG);

            bucket.put(blog, blog._id);
            await transaction.done;
        }).catch(() => {});
    }

    getBlog() {
        return new Promise((resolve) => {
            this.openDatabase().then(async(db) => {

                const transaction = db.transaction(BLOG, "readwrite");
                const bucket = transaction.objectStore(BLOG);
                const data = await bucket.getAll();
    
                resolve(data[0]);
            }).catch(() => {});
        });
    }

    saveRecommendedCircles(circles) {
        this.openDatabase().then(async(db) => {
            const transaction = db.transaction(RECOMMENDED_CIRCLES, "readwrite");
            const bucket = transaction.objectStore(RECOMMENDED_CIRCLES);

            circles.map(circle => bucket.put(circle, circle._id));
            await transaction.done;
        }).catch(() => {});
    }

    getRecommendedCircles() {
        return new Promise((resolve) => {
            this.openDatabase().then(async(db) => {

                const transaction = db.transaction(RECOMMENDED_CIRCLES, "readwrite");
                const bucket = transaction.objectStore(RECOMMENDED_CIRCLES);
                const data = await bucket.getAll();
    
                resolve(data);
            }).catch(() => {});
        });
    }
}